import React from 'react';
import {FormikErrors, withFormik} from 'formik';
import PropTypes from 'prop-types';
import {TermsConditions} from 'commons/models';
import {InferPropTypes} from 'commons/types/Types';
import InnerFormTerms from './InnerFormTerms';
import {Messages} from 'commons/constants';

TermsForm.propTypes = {
    submitHandler: PropTypes.func.isRequired,
    handleReturn: PropTypes.func.isRequired,
};

/* eslint-disable react/jsx-handler-names */
const FormControl = withFormik<InferPropTypes<typeof TermsForm.propTypes>, TermsConditions>({
    mapPropsToValues: () => {
        return {
            terms: false,
            access: false,
        };
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: TermsConditions) => {
        const errors: FormikErrors<TermsConditions> = {};
        if (!values.access) {
            errors.access = Messages.AUTH_REQUIRED;
        }
        if (!values.terms) {
            errors.terms = Messages.AUTH_REQUIRED;
        }
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler(values);
    },
})(InnerFormTerms);

function TermsForm(props: InferPropTypes<typeof TermsForm.propTypes>) {
    const {handleReturn, submitHandler} = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <div className='TermsForm'>
            <FormControl handleReturn={handleReturn} submitHandler={submitHandler} />
        </div>
    );
}

export default TermsForm;
